import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnquiriesComponent } from './enquiries/enquiries.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { LoadingIndicatorComponent } from '@usheru-hff/shared/ui-loading-indicator';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    SharedUtilsTranslationModule,
    MultiSelectModule,
    SharedUtilsModule,
    LoadingIndicatorComponent
  ],
  declarations: [EnquiriesComponent],
  exports: [EnquiriesComponent]
})
export class MovieDetailFeatureEnquiriesModule {}
